"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTENT_KIND = void 0;
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const bit_utils_constants_1 = require("@gcloud-npm/bit.utils.constants");
const bit_utils_common_1 = require("@gcloud-npm/bit.utils.common");
const bit_unifiedcomponents_text_info_1 = __importStar(require("@gcloud-npm/bit.unifiedcomponents.text-info"));
const bit_unifiedcomponents_button_1 = __importStar(require("@gcloud-npm/bit.unifiedcomponents.button"));
require("./NotFound.scss");
exports.CONTENT_KIND = {
    ERROR: 'ERROR',
    NOT_FOUND: 'NOT_FOUND',
};
const TEXTS = {
    [exports.CONTENT_KIND.ERROR]: {
        TITLE: '500',
        DESCRIPTION: '¡Ups! Aquí no hay nada. ¿Te rescatamos?',
        BUTTON_LABEL: 'Ir a inicio',
    },
    [exports.CONTENT_KIND.NOT_FOUND]: {
        TITLE: '404',
        DESCRIPTION: '¡Ups! Aquí no hay nada. ¿Te rescatamos?',
        BUTTON_LABEL: 'Ir a inicio',
    }
};
const COMPONENTS_PROPS = {
    TEXT_INFO_1: {
        [bit_utils_constants_1.DEVICES.TABLET]: {
            size: bit_unifiedcomponents_text_info_1.SIZE.DISPLAY3,
            fontType: bit_unifiedcomponents_text_info_1.FONT_TYPE.THIN,
            level: bit_unifiedcomponents_text_info_1.HEADING_LEVEL.H2,
            kind: bit_unifiedcomponents_text_info_1.KIND_TEXT.HEADING,
            align: bit_unifiedcomponents_text_info_1.ALIGN.CENTER,
            color: bit_unifiedcomponents_text_info_1.COLOR.WHITE,
        },
        [bit_utils_constants_1.DEVICES.PC]: {
            size: bit_unifiedcomponents_text_info_1.SIZE.DISPLAY1,
            fontType: bit_unifiedcomponents_text_info_1.FONT_TYPE.THIN,
            level: bit_unifiedcomponents_text_info_1.HEADING_LEVEL.H2,
            kind: bit_unifiedcomponents_text_info_1.KIND_TEXT.HEADING,
            align: bit_unifiedcomponents_text_info_1.ALIGN.CENTER,
            color: bit_unifiedcomponents_text_info_1.COLOR.WHITE,
        },
    },
    TEXT_INFO_2: {
        [bit_utils_constants_1.DEVICES.TABLET]: {
            size: bit_unifiedcomponents_text_info_1.SIZE.TITLE6,
            kind: bit_unifiedcomponents_text_info_1.KIND_TEXT.PARAGRAPH,
            align: bit_unifiedcomponents_text_info_1.ALIGN.CENTER,
            color: bit_unifiedcomponents_text_info_1.COLOR.WHITE,
            fontType: bit_unifiedcomponents_text_info_1.FONT_TYPE.LIGHT,
        },
        [bit_utils_constants_1.DEVICES.PC]: {
            size: bit_unifiedcomponents_text_info_1.SIZE.TITLE4,
            kind: bit_unifiedcomponents_text_info_1.KIND_TEXT.PARAGRAPH,
            align: bit_unifiedcomponents_text_info_1.ALIGN.CENTER,
            color: bit_unifiedcomponents_text_info_1.COLOR.WHITE,
            fontType: bit_unifiedcomponents_text_info_1.FONT_TYPE.LIGHT,
        },
    },
    BUTTON_1: {
        [bit_utils_constants_1.DEVICES.TABLET]: {
            color: bit_unifiedcomponents_button_1.BUTTON_COLOR.WHITE_BLUE,
            size: {
                w: bit_unifiedcomponents_button_1.BUTTON_WIDTH.MEDIUM,
                h: bit_unifiedcomponents_button_1.BUTTON_HEIGHT.LARGE,
            },
        },
        [bit_utils_constants_1.DEVICES.PC]: {
            color: bit_unifiedcomponents_button_1.BUTTON_COLOR.WHITE_BLUE,
            size: {
                w: bit_unifiedcomponents_button_1.BUTTON_WIDTH.MEDIUM,
                h: bit_unifiedcomponents_button_1.BUTTON_HEIGHT.LARGE,
            },
        },
    },
};
const reCalculateDevice = () => {
    let currentDevice = (0, bit_utils_common_1.getDeviceKindDependsOnViewPort)();
    if (currentDevice === bit_utils_constants_1.DEVICES.MOBILE) {
        currentDevice = bit_utils_constants_1.DEVICES.TABLET;
    }
    return currentDevice;
};
class NotFound extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            currentDevice: reCalculateDevice(),
        };
        this.setCurrentDevice = () => {
            this.setState({
                currentDevice: reCalculateDevice(),
            });
        };
        this.componentDidMount = () => {
            window.addEventListener('resize', this.setCurrentDevice);
        };
        this.componentWillUnmount = () => {
            window.removeEventListener('resize', this.setCurrentDevice);
        };
    }
    render() {
        const { currentDevice } = this.state;
        const { taggingInfo, kind } = this.props;
        return (react_1.default.createElement("div", { className: "NotFoundContentR1" },
            react_1.default.createElement(bit_unifiedcomponents_text_info_1.default, Object.assign({ text: TEXTS[kind].TITLE }, COMPONENTS_PROPS.TEXT_INFO_1[currentDevice])),
            react_1.default.createElement(bit_unifiedcomponents_text_info_1.default, Object.assign({ text: TEXTS[kind].DESCRIPTION }, COMPONENTS_PROPS.TEXT_INFO_2[currentDevice])),
            react_1.default.createElement(bit_unifiedcomponents_button_1.default, Object.assign({ label: TEXTS[kind].BUTTON_LABEL }, COMPONENTS_PROPS.BUTTON_1[currentDevice], { link: "https://www.movistar.es", className: "rescueButton", taggingInfo: taggingInfo }))));
    }
}
NotFound.PropTypes = {
    kind: prop_types_1.default.oneOf([exports.CONTENT_KIND.ERROR, exports.CONTENT_KIND.NOT_FOUND]),
};
NotFound.defaultProps = {
    kind: exports.CONTENT_KIND.NOT_FOUND,
};
exports.default = NotFound;
//# sourceMappingURL=index.js.map